import React from 'react';
import { AllowAllocationsControl } from 'src/components/enterprise/features/Employee/components/Form/controls/AllowAllocationsWrapper/AllowAllocationsControl';
import { useEmployeeFormContext } from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormProvider/useEmployeeFormContext';

export function AllowAllocationsWrapper(): JSX.Element {
  const {
    corpData: { allocationsPermitted },
  } = useEmployeeFormContext();

  if (!allocationsPermitted) {
    return null;
  }

  return (
    <AllowAllocationsControl
      id="allocationsPermitted"
      name="corpDinerSettings.allocationsPermitted"
    />
  );
}
